import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import {
  commonMessages,
  isEmptyObject,
  notificationSetting,
  notificationType,
  notUndefined,
  OwlSlider,
  showNotification,
} from "../Common";
import { BabyMintingService } from "../Services";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

export const SelectionContainer = React.forwardRef(
  (
    { currentDay, defaultPair, genesisData, handleGenesisSubmit, ...props },
    ref
  ) => {
    const [seperateGenesisList, setSeperateGenesisList] = useState([]);
    const [genesisContainer, setGenesisContainer] = useState();
    const [genesisInfo, setGenesisInfo] = useState({});
    const [stateUpdated, setStateUpdated] = useState(false);
    const [initialUpdate, setInitialUpdate] = useState(true);
    const [transactionDate, setTransactionDate] = useState();
    const genesisContainerRef = useRef();

    useEffect(() => {
      setGenesisInfo({ ...genesisData });
    }, [genesisData]);

    useEffect(() => {
      if (!isEmptyObject(genesisInfo)) {
        setData(genesisInfo);
        getSeperateGenesis(filterReverseActive(genesisInfo));
        if (initialUpdate) {
          setTransactionDate(
            moment(genesisInfo?.can_baby_mint_on).format("DD/MM/YYYY")
          );
          setInitialUpdate(false);
        } else {
          let maxDate = Math.max(
            genesisInfo?.genesis[0].txdate,
            genesisInfo?.genesis[1].txdate
          );
          let convertedDate = moment.unix(maxDate).format("DD/MM/YYYY");
          let addedDaysDate = moment(convertedDate, "DD/MM/YYYY")
            .add(currentDay?.day, "days")
            .format("DD/MM/YYYY");
          setTransactionDate(addedDaysDate);
        }
      }
    }, [genesisInfo]);

    useEffect(() => {
      //   console.log("List Changed: ", seperateGenesisList);
    }, [seperateGenesisList]);

    const setData = (genesisInfo) => {
      setGenesisContainer(() => {
        let tempArray = [];
        genesisInfo?.genesis.map((element, idx) => {
          tempArray.push(element);
        });

        return tempArray;
      });
    };

    const getSeperateGenesis = async (object) => {
      setSeperateGenesisList([]);
      BabyMintingService.getSeperateGenesis({
        wallet_address: genesisData?.wallet_address,
        gender: object?.genesisType,
        token_id: object?.token_id,
      }).then((response) => {
        if (response?.status === false) {
          showNotification(
            notificationType.DANGER,
            response.message,
            notificationSetting
          );
          // getSeperateGenesis(filterReverseActive(genesisInfo));
        } else if (response?.status === true) {
          if (response?.data?.length > 0) {
            setSeperateGenesisList(() => {
              let tempArray = [];

              response.data.map((element, index) => {
                // console.log(
                //   "Element: ",
                //   parseInt(element?.token_id),
                //   parseInt(
                //     genesisInfo.genesis[genesisInfo.activeIndex].token_id
                //   )
                // );
                tempArray.push({
                  ...element,
                  classname: `genesis-list ${
                    parseInt(
                      genesisInfo.genesis[genesisInfo.activeIndex].token_id
                    ) === parseInt(element?.token_id)
                      ? "active"
                      : ""
                  }`,
                });
              });
              return tempArray;
            });
          }
        }
      });
    };

    const updateGenesis = async (object) => {
      BabyMintingService.updateGenesisPair({
        wallet_address: genesisInfo?.wallet_address,
        female_token_id: genesisInfo?.genesis[0].token_id,
        male_token_id: genesisInfo?.genesis[1].token_id,
      }).then((response) => {
        if (response?.status === false) {
          showNotification(
            notificationType.DANGER,
            response.message,
            notificationSetting
          );
        } else if (response?.status === true) {
          showNotification(
            notificationType.SUCCESS,
            response.message,
            notificationSetting
          );
          handleGenesisSubmit();
        }
      });
    };

    // const filterActiveGenesisByType = (list, type) => {
    //   return list.filter(function (o) {
    //     return o.genesisType === type;
    //   })[0];
    // };

    const filterReverseActive = (genesisInfo) => {
      let activeIndex = genesisInfo?.activeIndex;
      return genesisInfo?.genesis.filter(function (o) {
        return parseInt(o.genesisIndex) !== activeIndex;
      })[0];
    };

    const replaceGenesis = (element) => {
      if (
        parseInt(genesisInfo.activeIndex) !== parseInt(element?.genesisIndex)
      ) {
        setGenesisInfo((genesisInfo) => {
          return {
            ...genesisInfo,
            activeIndex: element.genesisIndex,
            active: element.genesisType,
          };
        });
        setStateUpdated(false);
      }
    };

    const handleCardReplace = (cardData) => {
      if (
        parseInt(genesisInfo.genesis[genesisInfo.activeIndex].token_id) !==
        parseInt(cardData.token_id)
      ) {
        let tempData = genesisInfo;

        const toBeUpdated = {
          genesisType: cardData.gender,
          genesisIndex: genesisInfo.activeIndex,
          ...cardData,
        };

        tempData.genesis[genesisInfo.activeIndex] = toBeUpdated;
        let maxDate = Math.max(
          tempData?.genesis[0].txdate,
          tempData?.genesis[1].txdate
        );
        let convertedDate = moment.unix(maxDate).format("DD/MM/YYYY");
        let addedDaysDate = moment(convertedDate, "DD/MM/YYYY")
          .add(currentDay?.day, "days")
          .format("DD/MM/YYYY");

        let tempArray = seperateGenesisList;
        tempArray.map((element, idx) => {
          let newClass = "genesis-list";
          if (element.token_id === cardData.token_id) {
            element.classname = `${newClass} active`;
          } else {
            element.classname = newClass;
          }
          return element;
        });
        //   console.log("Temp Array:", tempArray);
        setSeperateGenesisList([...tempArray]);

        setData(tempData);
        setStateUpdated(true);
        setTransactionDate(addedDaysDate);
        if (notUndefined(genesisContainerRef.current.scrollIntoView)) {
          genesisContainerRef.current.scrollIntoView();
        }
      }
    };

    const handleUpdateGenesis = (event) => {
      event.preventDefault();
      if (
        parseInt(genesisInfo?.genesis[0].token_id) ===
          parseInt(defaultPair[0].token_id) &&
        parseInt(genesisInfo?.genesis[1].token_id) ===
          parseInt(defaultPair[1].token_id)
      ) {
        // showNotification(
        //   notificationType.DANGER,
        //   commonMessages.defaultPair,
        //   notificationSetting
        // );
        setStateUpdated(false);
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: commonMessages.changePairConfirmation,
          // html: "<h6>All the filled details are correct!<br/>Once you lock the data, you won&apos;t be able to edit it again.</h6/>",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Move Forward!",
          cancelButtonText: "No, let me check again!",
        }).then((result) => {
          if (result.isConfirmed) {
            updateGenesis();
          } else {
            // showNotification(
            //   notificationType.WARNING,
            //   commonMessages.userCancelled,
            //   notificationSetting
            // );
            // console.log("Cancelled");
          }
        });
      }
    };

    return (
      <>
        <p>
          Select which Female and Male you would like to pair together to
          manifest a divine Super Creators Jr.
        </p>
        <div className={"drag-drop-container"}>
          <h3>
            Select the Male & Female Tokens that you would like to pair together
          </h3>
          <div className={"genesis-container"} ref={genesisContainerRef}>
            {notUndefined(genesisContainer) &&
              genesisContainer.length > 0 &&
              genesisContainer.map((lastDroppedItem, idx) => (
                <>
                  <div
                    // ref={drop}
                    className={
                      "genesis-col" +
                      (parseInt(genesisInfo.activeIndex) ===
                      parseInt(lastDroppedItem?.genesisIndex)
                        ? " active"
                        : "")
                    }
                    data-testid="genesis_container"
                    onClick={() => replaceGenesis(lastDroppedItem)}
                  >
                    <img
                      src={lastDroppedItem?.image}
                      alt=""
                      title=""
                      className="img-fluid"
                    />
                    <p>{lastDroppedItem?.genesisType}</p>
                  </div>
                </>
              ))}
          </div>
          <div className="babydate">
            <i className="bi bi-calendar4-week"></i> 1<sup>st</sup> Super
            Creators Jr can be manifested on: <span>{transactionDate}</span>
          </div>
          <h3>
            Replace the currently selected token by choosing one of the
            available tokens below
          </h3>
          {notUndefined(seperateGenesisList) && seperateGenesisList.length > 0 && (
            <div className={"genesis-data-list custom-scroll"}>
              {seperateGenesisList.length > 0 &&
                seperateGenesisList.map((element, index) => (
                  <div
                    // ref={drag}
                    data-testid="genesis_list"
                    data-active={
                      genesisInfo.genesis[genesisInfo.activeIndex].token_id
                    }
                    data-token={parseInt(element?.token_id)}
                    data-lastDroppedItem={parseInt(
                      genesisContainer[genesisInfo.activeIndex].token_id
                    )}
                    className={element.classname}
                    //   className={
                    //     "genesis-list " +
                    //     (parseInt(
                    //       genesisInfo.genesis[genesisInfo.activeIndex].token_id
                    //     ) === parseInt(element?.token_id)
                    //       ? "active"
                    //       : "")
                    //   }
                    onClick={() => handleCardReplace(element)}
                    // style={{opacity }}
                  >
                    <i className="bi bi-check-circle-fill"></i>
                    <img src={element?.image} className="img-fluid" alt="" />
                    {/* {isDroppedCard ? <s>{name}</s> : name} */}
                  </div>
                ))}
              {/* <OwlCarousel
                {...{
                  nav: false,
                  dots: true,
                  margin: 20,
                  stagePadding: 0,
                  autoplay: false,
                  responsive: {
                    0: {
                      items: 2,
                    },
                    575: {
                      items: 3,
                    },
                    768: {
                      items: 4,
                    },
                    1280: {
                      items: 6,
                    },
                    1600: {
                      items: 7,
                    },
                  },
                }}
              >
                
              </OwlCarousel> */}
            </div>
          )}
        </div>
        <p className="terms">
          By clicking on the below button you agree with the updated date of
          fuse on the above-selected pair. You can create the 1<sup></sup>st Super
          Creators Jr on <span>{transactionDate}</span>.
        </p>
        <div className="text-center">
          <button
            type="button"
            className="btn"
            onClick={handleUpdateGenesis}
            disabled={!stateUpdated}
          >
            Agreed & Update
          </button>
        </div>
      </>
    );
  }
);
